/**
 * Tiny event emitter (no external deps).
 */
export function createEmitter() {
  var listeners = {};

  function on(event, fn) {
    if (!listeners[event]) {
      listeners[event] = [];
    }
    listeners[event].push(fn);
    return function unsubscribe() {
      off(event, fn);
    };
  }

  function once(event, fn) {
    var wrap = function () {
      off(event, wrap);
      fn.apply(null, arguments);
    };
    return on(event, wrap);
  }

  function off(event, fn) {
    var list = listeners[event];
    if (!list) {
      return;
    }
    listeners[event] = list.filter(function (f) {
      return f !== fn;
    });
  }

  function emit(event) {
    var args = Array.prototype.slice.call(arguments, 1);
    var list = listeners[event] ? listeners[event].slice() : [];
    for (var i = 0; i < list.length; i++) {
      try {
        list[i].apply(null, args);
      } catch (e) {
        if (typeof console !== "undefined" && console.error) {
          console.error("[video-player] listener error", e);
        }
      }
    }
  }

  function removeAllListeners() {
    listeners = {};
  }

  return {
    on: on,
    once: once,
    off: off,
    emit: emit,
    removeAllListeners: removeAllListeners,
  };
}

export default createEmitter;
